import React from 'react';
import { carleadCreationGetInitialProps, } from '@wkda/carlead-creation-components';
import {
  BaseLeadPage,
  CarleadHIWWhyChooseWkdaFaq,
  CarleadLicensePlateNLCustomerCounter
} from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <BaseLeadPage
      form={CarleadLicensePlateNLCustomerCounter}
      content={CarleadHIWWhyChooseWkdaFaq}
      headlineDesktop='carleadCreation.form.title'
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
